export const TAX_YEAR_END_DATE_MASK = '##/##';
